import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
    Suspense,
} from "react";
import {
    deleteItem,
    fetchData,
} from "../../../utils/apiUtils";

import DeleteModel from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import UploadFileTable from "./UploadFileTable";
import AddFile from "./AddFile";
import PerPageSelect from "../../../Components/PerPageSelect";
const UploadFile = () => {
    const [loading, setLoading] = useState(true);
    const [media, setmedia] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const totalPages = useMemo(
        () => Math.ceil(totalCount / perPage),
        [totalCount, perPage]
    );



    const fetchmedia = useCallback(
        async (page = 1, searchQuery = "") => {
            setLoading(true);
            await fetchData(
                "media-pagination",
                { perPage, pageNo: page, search: searchQuery },
                setmedia,
                setTotalCount,
                setCurrentPage,
                setLoading
            );
        },
        [perPage]
    );

    useEffect(() => {
        const delay = 0;
        const handler = setTimeout(() => {
            fetchmedia(1);
        }, delay);

        return () => clearTimeout(handler);
    }, [perPage]);



    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("media", deleteItemId?.id, fetchmedia, [deleteItemId?.path]);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (err) {
            throw err;
        } finally {
            setIsDeleting(false);
        }
    };



    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchmedia(page);
        }
    };

const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };
    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Upload Images", path: "*" },
    ];



    return (
        <>
            <div className="content-wrapper">


                <div
                    className="page-header mt-5"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <h3 className="custom-page-title">Upload Images</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>
                <AddFile callBack={fetchmedia}/>
                <div
                    className="d-flex justify-content-between mb-2"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
                >
                    <PerPageSelect value={perPage} onChange={setPerPage}/>
                </div>

                <UploadFileTable
                    loading={loading}
                    media={media}
                    currentPage={currentPage}
                    perPage={perPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    handlePageClick={handlePageClick}
                    handleDelete={handleDelete}
                />
            </div>
            <Suspense fallback={<div>Loading...</div>}>
                <DeleteModel
                    deleteModalOpen={deleteModalOpen}
                    setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                    onConfirm={confirmDelete}
                    itemName="Media"
                    isDeleting={isDeleting}
                />
            </Suspense>
        </>
    );
};

export default UploadFile;
